import Vue from 'vue'

// Menu state management using Vue.observable for hover-based submenus
const menuState = Vue.observable({
  activeSubmenu: null,
  isMouseOverSubmenu: false
})

export default {
  // Open a submenu
  openSubmenu (itemId) {
    menuState.activeSubmenu = itemId
  },

  // Close the submenu
  closeSubmenu () {
    menuState.activeSubmenu = null
    menuState.isMouseOverSubmenu = false
  },

  // Check if a submenu is open
  isSubmenuOpen (itemId) {
    return menuState.activeSubmenu === itemId
  },

  // Set mouse over submenu state
  setMouseOverSubmenu (value) {
    menuState.isMouseOverSubmenu = value
  },

  // Get current active submenu
  getActiveSubmenu () {
    return menuState.activeSubmenu
  },

  // Get the observable state directly (for Vue computed properties)
  getState () {
    return menuState
  }
}
